// https://git.microline.ru/zont/server/-/issues/1657
export function fixObjectName(hc_name) {
    const split = hc_name.split('|');
    return split[0];
}
